import EmpresaNotesAPI from '../../api/empresaNotes';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getNotesByEmpresa: _state => empresaId => {
    const records = _state.records[empresaId] || [];
    return [...records].sort((r1, r2) => r2.id - r1.id);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }, { empresaId }) {
    commit('setUIFlag', { isFetching: true });
    try {
      const { data } = await EmpresaNotesAPI.get(empresaId);
      commit('setNotes', { empresaId, data });
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },

  async create({ commit }, { empresaId, content }) {
    commit('setUIFlag', { isCreating: true });
    try {
      const { data } = await EmpresaNotesAPI.create(empresaId, content);
      commit('addNote', { empresaId, data });
      return data;
    } finally {
      commit('setUIFlag', { isCreating: false });
    }
  },

  async delete({ commit }, { empresaId, noteId }) {
    commit('setUIFlag', { isDeleting: true });
    try {
      await EmpresaNotesAPI.delete(empresaId, noteId);
      commit('deleteNote', { empresaId, noteId });
    } finally {
      commit('setUIFlag', { isDeleting: false });
    }
  },
};

export const mutations = {
  setUIFlag(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  setNotes($state, { empresaId, data }) {
    $state.records = { ...$state.records, [empresaId]: data };
  },
  addNote($state, { empresaId, data }) {
    const notes = $state.records[empresaId] || [];
    $state.records = { ...$state.records, [empresaId]: [data, ...notes] };
  },
  deleteNote($state, { empresaId, noteId }) {
    const notes = $state.records[empresaId] || [];
    $state.records = {
      ...$state.records,
      [empresaId]: notes.filter(note => note.id !== noteId),
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
